// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreSeller = (client) => ({
    /**
     * `GET /store/seller`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetSellers
     * @source packages/modules/b2c-core/src/api/store/seller/route.ts
     */
    list: (query, headers) => client.fetch("/store/seller", { method: "GET", query, headers }),
    /**
     * `GET /store/seller/:handle/applications`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetSellerApplications
     * @source packages/modules/b2c-core/src/api/store/seller/[handle]/applications/route.ts
     */
    listApplications: (handle, query, headers) => client.fetch(buildPath("/store/seller/:handle/applications", [handle]), { method: "GET", query, headers }),
    /**
     * `GET /store/seller/:handle/product-ids`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreSellerHandleProductIdsRetrieve
     * @source packages/modules/b2c-core/src/api/store/seller/[handle]/product-ids/route.ts
     */
    listProductIds: (handle, query, headers) => client.fetch(buildPath("/store/seller/:handle/product-ids", [handle]), { method: "GET", query, headers }),
    /**
     * `GET /store/seller/:handle`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetSellerByHandle
     * @source packages/modules/b2c-core/src/api/store/seller/[handle]/route.ts
     */
    retrieve: (handle, query, headers) => client.fetch(buildPath("/store/seller/:handle", [handle]), { method: "GET", query, headers }),
});
//# sourceMappingURL=seller.js.map